
import Routes from "./ProjectRoutes"

function App() {
  return (
    <Routes />
  );
}

export default App;
